import { MondayErrorCodes } from "shared/integrations/monday-types";
import {
  ARCHIVED_SVG,
  DELETED_SVG,
  LOCKED_SVG,
  VIEWER_ONLY_SVG,
  ACCOUNT_MISMATCH_SVG,
  FAILED_TO_LOAD_SVG,
} from "./error-icons";

export interface ErrorConfig {
  message: string;
  icon: string;
}

export function getErrorConfig(code: MondayErrorCodes | undefined): ErrorConfig {
  switch (code) {
    case MondayErrorCodes.NOT_FOUND: {
      return {
        message: "No access to this item",
        icon: LOCKED_SVG,
      };
    }
    case MondayErrorCodes.BOARD_ARCHIVED: {
      return {
        message: "This item's board has been archived",
        icon: ARCHIVED_SVG,
      };
    }
    case MondayErrorCodes.BOARD_DELETED: {
      return {
        message: "This item's board has been deleted",
        icon: DELETED_SVG,
      };
    }
    case MondayErrorCodes.ARCHIVED: {
      return {
        message: "This item has been archived",
        icon: ARCHIVED_SVG,
      };
    }
    case MondayErrorCodes.DELETED: {
      return {
        message: "This item has been deleted",
        icon: DELETED_SVG,
      };
    }
    case MondayErrorCodes.ACCOUNT_MISMATCH: {
      return {
        message: "This item is from another account",
        icon: ACCOUNT_MISMATCH_SVG,
      };
    }
    case MondayErrorCodes.LOGIN_REQUIRED: {
      return {
        message: "This item cannot be viewed by guests",
        icon: VIEWER_ONLY_SVG,
      };
    }
    case MondayErrorCodes.UNKNOWN_ERROR: {
      return {
        message: "Unable to load item",
        icon: FAILED_TO_LOAD_SVG,
      };
    }
    default: {
      return {
        message: "Failed loading this item",
        icon: FAILED_TO_LOAD_SVG,
      };
    }
  }
}
